import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
export function getRect(el) {
  return {
    top: el.offsetTop,
    left: el.offsetLeft,
    width: el.offsetWidth,
    height: el.offsetHeight
  };
}
export function camelize(str) {
  str = String(str);
  return str.replace(/-(\w)/g, function (m, c) {
    return c ? c.toUpperCase() : '';
  });
}

var vendor = function () {
  var inBrowser = typeof window !== 'undefined';

  if (!inBrowser) {
    return false;
  }

  var elementStyle = document.createElement('div').style;
  var transformNames = {
    standard: 'transform',
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform'
  };

  for (var key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key;
    }
  }

  return false;
}();

export function prefixStyle(style) {
  if (vendor === false) {
    return false;
  }

  if (vendor === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend';
    }

    return style;
  }

  return vendor + style.charAt(0).toUpperCase() + style.substr(1);
}